module.exports = __webpack_public_path__ + "img/hands.05ac5220.svg";